import { authApiService } from '@/api/authApiService';
import {
  ApiResponseType,
  BillingCurrentPlanType,
  BillingSubscriptionType,
  ListResponseType,
  Maybe,
} from '@/types/sharedTypes';
import { ApiParams } from '@/api/helpers/apiHelpers';
import { OrganizationType } from '@/bundle/_Opco/types/types';

export type OrganizationListItemType = OrganizationType & {
  billing_profile: Maybe<{
    current_plan: Pick<BillingCurrentPlanType, 'id' | 'name' | 'billing_frequency'>;
    subscription: Pick<BillingSubscriptionType, 'id' | 'status' | 'cancel_at_period_end' | 'current_period_end'>;
  }>;
};

export const getOrganizationsApi = (
  params: ApiParams
): Promise<ApiResponseType<ListResponseType<OrganizationType>>> => {
  const uri = '/opco/organizations/';

  return authApiService.GET(uri, params);
};
